import { camelizeKeys } from 'humps';
import { api, endpoints }  from '@dom/utils';

const fetchInvoiceData = async invoiceId => {
  const { data } = await api.get(endpoints.payment.getInvoice(invoiceId));
  return camelizeKeys(data);
};

export default fetchInvoiceData;
